<template>
  <div class="min-h-integrationCard flex flex-col justify-between shadow-appComponent border-signableBrandColours-midGrey border-solid border-1 rounded-xl p-base">
    <div class="integration-overview">
      <VIntegrationStatus
        :integration="integration">
      </VIntegrationStatus>
      <img :src="integrationImage">
      <h2>
        {{ $t(`companySettings.integrations.${integration.slug}.name`) }}
      </h2>
      <p>
        {{ $t(`companySettings.integrations.${integration.slug}.headline`) }}
      </p>
    </div>
    <div>
      <BaseButton
        @click.native="manageIntegration"
        class="mt-base"
        :data-ec="`integration_overview_${integration.slug}`"
        data-et="manage_integration_button"
      >
        <span>{{ ctaText }}</span>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import VIntegrationStatus from '@/views/components/IntegrationStatus.vue';
import integrationsManagementMixin from '@/mixins/integrationsManagementMixin';

export default {
  name: 'VIntegrationOverview',
  components: {
    BaseButton,
    VIntegrationStatus,
  },
  props: {
    integration: {
      type: [Object],
      required: true,
    },
  },
  mixins: [
    integrationsManagementMixin,
  ],
  data() {
    return {
      comingSoonPillTheme: {
        defaultContainerClasses: 'bg-signableBrandColours-brightBlue border-signableBrandColours-brightBlue',
        defaultTextClasses: 'text-signableBrandColours-black text-11 font-semibold',
      },
    };
  },
  computed: {
    ctaText() {
      if (this.hasInstance) {
        return this.$t('companySettings.integrations.manage');
      }

      return this.$t('companySettings.integrations.connect');
    },
    integrationImage() {
      return `/img/integrations/${this.integration.slug}.png`;
    },
  },
  methods: {
    manageIntegration() {
      const { slug } = this.integration;

      if (this.hasInstance) {
        this.$emit('openManageIntegrationModal', slug);
      } else {
        this.$emit('loadingStateChanged', true);

        this.$store.dispatch('integrations/CREATE_INTEGRATION_INSTANCE', { slug }).finally(() => {
          this.$emit('loadingStateChanged', false);
          this.$emit('openManageIntegrationModal', slug);
        });
      }
    },
  },
};

</script>

<style scoped>
.integration-overview {
  display: block;
  position: relative;
  background: #ffffff;
  clear: both;
  overflow: auto;
}
.integration-overview img {
  width: 50px;
  height: 50px;
  margin-bottom: var(--spacing-base);
}
</style>
